import { render, staticRenderFns } from "./HistoricLimitItem.vue?vue&type=template&id=39cde937"
import script from "./HistoricLimitItem.vue?vue&type=script&lang=js"
export * from "./HistoricLimitItem.vue?vue&type=script&lang=js"
import style0 from "./HistoricLimitItem.vue?vue&type=style&index=0&id=39cde937&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports